
import $ from "jquery";
import Flickity from "flickity-fade";
import "flickity-imagesloaded";

class SinglePropertySlider {
    constructor($el) {
        this.$el = $el;
        this.$dots = null;
        this.$nextBtn = null;

        this.options = {
            pageDots: false,
            wrapAround: true,
            prevNextButtons: true,
            fade: true,
            cellSelector: '.property-presentation__slider-item',
			cellAlign: 'center'
        };

        if(this.$el.length) {
            this._init();
            // this._bindEvents();
        }
    }

    _init() {
        this.$slides = this.$el.find('.property-presentation__slider-item');
        this.slidesCount = this.$slides.length;

		if(this.slidesCount > 1) {
            this._createSlider();
        }
    }

	_createSlider() {
        new Flickity(this.$el[0], this.options);
    }

}

export default SinglePropertySlider;
